<template>
  <div id="smsLog">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'smsLog'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/log/sms/SmsLog.vue